import { Spinner } from "react-bootstrap";
import classes from "./index.module.css";

const LoaderOverlay = () =>
<div className={classes.spinnerContainer}>
  <Spinner animation="grow" className={classes.spinner} />
</div>

export default LoaderOverlay;
